import { nextCargoApi } from "../../baseApi";
import { GetPopupsActiveByCompany, SavePopupsRead } from "./popups.types";

export const popupsApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    getPopupsActiveByCompany: build.query<GetPopupsActiveByCompany["result"], GetPopupsActiveByCompany["args"]>({
      query: ({ id }) => `/popups/company/active/${id}`
    }),
    savePopupsRead: build.mutation<SavePopupsRead["result"], SavePopupsRead["args"]>({
      query: ({ skipInvalidate: _, ...body }) => ({
        url: "/popups/read",
        method: "POST",
        body
      })
    })
  })
});

popupsApi.enhanceEndpoints({
  endpoints: {
    getPopupsActiveByCompany: {
      providesTags: (result, err, { id }) => [
        { type: "PopupsByCompany", id },
        ...(result ? result.map((item) => ({ type: "Popup" as const, id: item.id })) : [{ type: "Popup" as const, id: "LIST" }])
      ]
    },
    savePopupsRead: {
      invalidatesTags: (result, err, { company, skipInvalidate }) => (skipInvalidate ? [] : [{ type: "PopupsByCompany", id: company.id }])
    }
  }
});
